var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(! _vm.isRevealed)?_c('button',{staticClass:"btn",attrs:{"disabled":_vm.isReadOnly,"v-tooltip":_vm.config.instructions},domProps:{"textContent":_vm._s(_vm.config.display)},on:{"click":_vm.reveal}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }